import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ClientService } from 'src/app/services/client.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss'],
})
export class TransactionsComponent implements OnInit {

  orders: any[];
  document = '';
  interval: any;

  constructor(private clientService: ClientService, private navCtrl: NavController) { }

  ngOnInit() {
    this.getTransactions();
    this.document = Security.getDocument();

    this.startGetByMinute();
  }

  async getTransactions() {
    this.clientService.getLatestTransactions().subscribe(result => {
      if (result.success) {
        this.orders = result.data;
      }
    });
  }

  goToPage(page: any) {
    const uri = '/master/wallet/extract/details/';
    this.navCtrl.navigateForward( uri + page);
  }

  goToAll(){
    this.navCtrl.navigateForward('/master/wallet/extract/transactions');
  }

  async startGetByMinute() {
    this.interval = setInterval(async () => {
      await this.getTransactions();
    }, 60000);
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy() {
    clearInterval(this.interval);
  }

}
